/**
 * Conversation List Item Component
 * Wraps ConversationsContainer for a single conversation with independent state
 */

import React from 'react';
import { ConversationsContainer } from '../ConversationsContainer';
import { ChatMessage, ChatLocation } from '@/types/chatTypes';

export interface ConversationListItemProps {
  conversationId: string;
  sessionId: string;
  initialMessages?: ChatMessage[] | null;
  onPlaceSelect?: (location: ChatLocation) => void;
  onCardClick?: (cardId: string) => void;
  onPlaceNameClick?: (placeName: string) => void;
}

export const ConversationListItem: React.FC<ConversationListItemProps> = ({
  conversationId,
  sessionId,
  initialMessages,
  onPlaceSelect,
  onCardClick,
  onPlaceNameClick,
}) => {
  React.useEffect(() => {
    console.log('📦 [ConversationListItem] Rendering item:', {
      conversationId,
      sessionId,
      initialMessagesCount: initialMessages?.length || 0,
      initialMessageRoles: initialMessages?.map(m => m.role) || [],
      initialMessageSessionIds:
        initialMessages?.map(m => m.session_id).filter(Boolean) || [],
      hasExperiences:
        initialMessages?.some(m => m.experiences && m.experiences.length > 0) ||
        false,
      experienceCounts:
        initialMessages
          ?.filter(m => m.experiences)
          .map(m => ({ role: m.role, count: m.experiences?.length || 0 })) ||
        [],
    });
  }, [conversationId, sessionId, initialMessages]);

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ConversationsContainer
        conversationId={conversationId}
        initialMessages={initialMessages}
        initialSessionId={sessionId}
        onCardClick={onCardClick}
        onPlaceNameClick={onPlaceNameClick}
        onPlaceSelect={onPlaceSelect}
      />
    </div>
  );
};
